import React from 'react';
import { useState, useContext } from 'react';
import { ProductDetail, ProductListItem } from '../types/ProductTypes';

interface PaginationInfo {
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

type ProductContextType = {
    productList: ProductDetail[] | null;
    setProductList: (products: ProductDetail[] | null) => void;
    filteredProductList: ProductDetail[] | null;
    setFilteredProductList: (products: ProductDetail[] | null) => void;
    productListItems: ProductListItem[];
    setProductListItems: (items: ProductListItem[]) => void;
    pagination: PaginationInfo;
    setPagination: (info: PaginationInfo) => void;
    isProductListRetrieved: boolean;
    setIsProductListRetrieved: (retrieved: boolean) => void;
    isProductListLoading: boolean;
    setIsProductListLoading: (loading: boolean) => void;
    selectedProduct: ProductListItem | null;
    setSelectedProduct: (product: ProductListItem | null) => void;
};

export const ProductContext = React.createContext<ProductContextType>(undefined!);

interface ProductContextProviderProps {
    children: React.ReactNode;
}

const DEFAULT_PAGINATION: PaginationInfo = {
    totalCount: 0,
    pageNumber: 1,
    pageSize: 50,
    totalPages: 0,
};

export const ProductContextProvider = ({ children }: ProductContextProviderProps) => {
    const [productList, setProductList] = useState<ProductDetail[] | null>(null);
    const [filteredProductList, setFilteredProductList] = useState<ProductDetail[] | null>(null);
    const [productListItems, setProductListItems] = useState<ProductListItem[]>([]);
    const [pagination, setPagination] = useState<PaginationInfo>(DEFAULT_PAGINATION);
    const [isProductListRetrieved, setIsProductListRetrieved] = useState<boolean>(false);
    const [isProductListLoading, setIsProductListLoading] = useState<boolean>(false);
    const [selectedProduct, setSelectedProduct] = useState<ProductListItem | null>(null);

    return (
        <ProductContext.Provider
            value={{
                productList,
                setProductList,
                filteredProductList,
                setFilteredProductList,
                productListItems,
                setProductListItems,
                pagination,
                setPagination,
                isProductListRetrieved,
                setIsProductListRetrieved,
                isProductListLoading,
                setIsProductListLoading,
                selectedProduct,
                setSelectedProduct,
            }}
        >
            {children}
        </ProductContext.Provider>
    );
};

export const useProductStore = () => useContext(ProductContext);
